import { render, staticRenderFns } from "./IncidentsTable.vue?vue&type=template&id=ef9c8b2e&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./IncidentsTable.vue?vue&type=script&lang=js"
export * from "./IncidentsTable.vue?vue&type=script&lang=js"
import style0 from "./IncidentsTable.vue?vue&type=style&index=0&id=ef9c8b2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9c8b2e",
  null
  
)

export default component.exports